import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateMLAsset } from './state_ml_asset';

export const local_ml_asset_reservations_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.ML_ASSET_RESERVATION_DELETE,
  payload,
});

export function init_local_ml_asset_reservation_delete(state: StateMLAsset, action: PayloadAction<string[]>) {
  if (action.payload.length == 0) return;

  for (let reservation_id of action.payload) {
    for (let diffusion_model_reservations_map of state.reservations_current_workspace_active_map.values()) {
      diffusion_model_reservations_map.delete(reservation_id);
    }

    state.reservations_map_all.delete(reservation_id);
  }

  //need to force re-render
  state.reservations_current_workspace_active_map = new Map(state.reservations_current_workspace_active_map);

  //need to force re-render
  state.reservations_map_all = new Map(state.reservations_map_all);
}
